import { Button, Card, Col, Form, Row } from "react-bootstrap";
import QRCode from "react-qr-code";
import { FaEye } from "react-icons/fa";
import { useEffect, useState } from "react";
import { authServices } from "../../../APIServices/UserData/authServices";

const SetupAnotherDevice = () => {
  const [hidden, setHidden] = useState(true);
  const [loginQRCode, setLoginQRCode] = useState("");
  const generateQRForMobileLogin = async () => {
    let data = await authServices.generateQRForMobileLogin();
    setLoginQRCode(data?.qrToken || "");
  };

  useEffect(() => {
    generateQRForMobileLogin();
    const interval = setInterval(
      () => {
        generateQRForMobileLogin();
      },
      1 * 60 * 1000,
    );
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="h-100 d-flex flex-column">
      {/* Header */}
      <div className="bg-white border-bottom px-4 py-3">
        <div className="hstack justify-content-between">
          <h6 className="fw-semibold m-0">Setup Another Device</h6>
        </div>
      </div>

      {/* Content */}
      <div className="flex-grow-1 overflow-auto p-4">
        <Row className="g-4 justify-content-center">
          <Col xxl={6} xl={7} lg={8} md={10}>
            <Card className="border-0 shadow-sm">
              <Card.Body>
                <Row>
                  <Form.Group as={Col} md={5} className="my-2">
                    <div className="border p-2 rounded-1 position-relative">
                      <div
                        className={`position-absolute text-muted px-2 bg-white`}
                        style={{
                          fontSize: 10,
                          top: -8,
                          left: "50%",
                          transform: "translateX(-50%)",
                        }}
                      >
                        SETUP CODE
                      </div>
                      <div
                        className="position-relative"
                        style={{ userSelect: "none" }}
                      >
                        {hidden ? (
                          <QRCode
                            className="p-3"
                            style={{
                              filter: "blur(5px) brightness(0.6)",
                              userSelect: "none",
                              pointerEvents: "none",
                              transition: "filter 0.3s ease",
                            }}
                            value={loginQRCode}
                            size={200}
                          />
                        ) : (
                          <QRCode
                            className="p-3"
                            value={loginQRCode}
                            size={200}
                          />
                        )}
                        {hidden && (
                          <div
                            className="position-absolute top-50 start-50 text-white"
                            style={{ transform: "translate(-50%, -50%)" }}
                          >
                            <FaEye style={{ fontSize: 25 }} />
                          </div>
                        )}
                      </div>
                      <div
                        className={`position-absolute bg-white`}
                        style={{
                          bottom: -13,
                          left: "50%",
                          transform: "translateX(-50%)",
                        }}
                      >
                        <Button
                          variant="outline-primary"
                          className="rounded-1 py-1 px-3 "
                          style={{ fontSize: 10 }}
                          onClick={() => setHidden(!hidden)}
                        >
                          {hidden ? "SHOW" : "HIDE"}
                        </Button>
                      </div>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} md={7}>
                    <Form.Label className="small mb-3">Step Two</Form.Label>
                    <h6 className="mb-3">Scan this code to sign in</h6>
                    <ul className="small text-muted">
                      <li className="mb-3">
                        Open the PIXA Connects mobile app on a device where
                        you’re not signed in.
                      </li>
                      <li className="mb-3">Select “Sign in.”</li>
                      <li className="mb-3">Select “Scan QR Code.”</li>
                    </ul>
                  </Form.Group>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SetupAnotherDevice;
